// extracted by mini-css-extract-plugin
export default {"root":"PnSRC9IZ","sell":"m0NGsn69","buy":"wHXUvhdo","title":"UQRaan90","value":"fzo2LWAE","tickerName":"xl8VJALy","time":"kexR3lJS"};